<script>
import * as m from '@app/paraglide/messages.js';
import { showModal } from '@app/store/modalStore.svelte.js';
</script>

<li class="nav-item" title={m.toolbar_secondary_export_file_title()}>
    <a
        class="nav-link"
        href="#!/"
        role="button"
        aria-label={m.toolbar_secondary_export_file_aria_label()}
        onclick={() => showModal('fileExport')}
    ><i class="bi bi-upload"></i></a>
</li>
